import usePageMetadata from '@hooks/usePageMetadata'

const useIsInRecipeContent = (): boolean => {
  const pageMetadata = usePageMetadata()
  return pageMetadata.targetContentType === 'recipe'
}

export default useIsInRecipeContent
